module.exports = __webpack_public_path__ + "static/media/14.391e880a.jpg";